import React from 'react';
import { NavLink } from 'react-router-dom';
import { useWorkAndConnections } from '../data';
import { useTranslation } from 'react-i18next';

const How = () => {
	const { t } = useTranslation();
	const { work } = useWorkAndConnections();

	return (
		<section>
			<div className='container py-20'>
				<div className='flex flex-col md:flex-row gap-3 mb-10 w-full'>
					<div className='flex flex-col w-full md:w-2/3'>
						<p className='text-main text-md font-medium'>{t('whatWeDo')}</p>
						<p className='text-main text-4xl font-semibold'>
							{t('howItWorks')}
						</p>
					</div>
					<p className='text-textColor text-md'>{t('howItWorksText')}</p>
				</div>
				<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
					{work.map((e, index) => (
						<NavLink
							to={e.readmore}
							key={index}
							className='card flex flex-col bg-section gap-5 p-10 items-center rounded-lg border-white border-solid border-2 md:hover:border-secondary transition-all duration-500'>
							<div className='image text-white border-2 border-secondary bg-white flex justify-center items-center p-2 relative rounded-md w-20 h-20'>
								<span className='absolute top-0 left-full text-white w-8 h-8 flex justify-center items-center p-4 rounded-full bg-main transform -translate-x-1/2 -translate-y-1/2'>
									{e.afterimage}
								</span>
								<img
									loading='lazy'
									src={e.Image}
									alt={e.alt}
								/>
							</div>

							<h3 className='text-textColor font-bold'>{e.title}</h3>
							<p className='text-textColor text-center'>{e.data}</p>
							<span className='text-main font-meduim'>{t('readMore')}</span>
						</NavLink>
					))}
				</div>
			</div>
		</section>
	);
};

export default How;
